// Shared cookie helpers for consent + GA gating.
export function setCookie(name: string, value: string, maxAgeSeconds: number) {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=${value}; max-age=${maxAgeSeconds}; path=/; SameSite=Lax`;
}

export function getCookie(name: string) {
  if (typeof document === 'undefined') return null;
  const value = document.cookie
    .split(';')
    .map((c) => c.trim())
    .find((c) => c.startsWith(`${name}=`));
  return value ? value.split('=')[1] : null;
}
